import { AllowedFilterOperator } from '@wix/wix-data-schema-types'

const COLLECTION_FIELD = /[^{}]+(?=\})/g
const NON_LETTER_OR_NUMBER = /[^\dA-Za-z]/g
const STATIC_PARTS = /[^}]+(?=\{|$)/g

export const cleanUrl = (url: string): string =>
  url.replace(/(\/{2,})/g, '/').replace(/^\//, '')

export const parseUrlPattern = (
  pattern: string,
): { fields: string[]; nonFields: string[] } => {
  pattern = cleanUrl(pattern)
  return {
    fields: pattern.match(COLLECTION_FIELD) || [],
    nonFields: pattern
      .replace(COLLECTION_FIELD, '')
      .split(NON_LETTER_OR_NUMBER)
      .filter(x => !!x),
  }
}

export const getUrlParts = (pattern: string) =>
  pattern.split('/').filter(s => s.length > 0)

export const parseUrl = (url: string): { prefix: string; pattern: string } => {
  url = cleanUrl(url)
  const urlParts = getUrlParts(url)
  const pattern = '/' + urlParts.slice(1).join('/')
  return {
    prefix: urlParts[0],
    pattern,
  }
}

export const buildUrl = (prefix: string, pattern: string): string =>
  cleanUrl(`${prefix}/${pattern}`)

export const addField = (url: string, field: string): string =>
  cleanUrl(`${url}/{${field}}`)

export const isEqual = (url1: string, url2: string): boolean =>
  cleanUrl(url1) === cleanUrl(url2)

export const lowerCaseStaticUrlParts = (url: string): string =>
  url.replace(STATIC_PARTS, s => s.toLowerCase())

export const pagelinkFieldCanBeSorted = ({
  queryOperators,
}: {
  queryOperators?: AllowedFilterOperator[]
}): boolean => {
  const queryOperatorsForSorting = [
    AllowedFilterOperator.gt,
    AllowedFilterOperator.lt,
  ]
  return (
    !queryOperators ||
    queryOperatorsForSorting.every(operator =>
      queryOperators.includes(operator),
    )
  )
}
